const buildRelatedValueParams = (relatedValue) => {
    let relatedValueAppend = [];

    if (typeof relatedValue === 'string') {
        relatedValue = relatedValue.split(',');
    }
    if (Array.isArray(relatedValue) && relatedValue.length > 0) {
        for (let val of relatedValue) {
            relatedValueAppend.push(`specialty_id[]=${val}`);
        }
    }

    return relatedValueAppend;
};

const buildSelectedValuesParams = (selectedValue) => {
    let selectedValueAppend = [];

    if (Array.isArray(selectedValue) && selectedValue.length > 0) {
        for (let val of selectedValue) {
            if (val !== '') {
                selectedValueAppend.push(`v[]=${val}`);
            }
        }
    }

    return selectedValueAppend;
};

const instanceSelect2 = ($input) => {
    const selected = $input.data('value') ?? '';
    const placeholder = $input.data('placeholder') ?? $input.attr('placeholder') ?? '';
    const isMultiple = ($input.attr('multiple') ?? '') === 'multiple';
    let source = $input.data('source');
    let related = $input.data('related');
    let $related = related ? $(related) : null;

    $input.select2({
        ajax: {
            url: () => {
                let params = buildSelectedValuesParams(selected.toString().split(','));

                let relatedValue = $related?.val();
                if (relatedValue !== null) {
                    params = [...params, ...buildRelatedValueParams(relatedValue)];
                }

                return `${source}?${params.join('&')}`;
            },
            dataType: 'json',
            delay: 400,
        },
        placeholder: placeholder,
        closeOnSelect: !isMultiple,
        allowClear: true,
        dropdownParent: $input.parent(),
    });

    $related?.on('select2:unselecting', () => {
        $input.val(null).trigger('change');
    });
};

const LicensesSearch = {
    init: () => {
        const $licenseSearchFields = $('[data-license-search="1"]');
        for (let field of $licenseSearchFields) {
            let $licenseSearch = $(field);
            instanceSelect2($licenseSearch);
        }
    },
};

export default LicensesSearch;
